import React, { CSSProperties, ReactNode } from "react";
import "./list-item.css";

interface ListItemProps {
    style?:CSSProperties;
    icon?:ReactNode;
    primary?:string;
    secondary?:string | ReactNode;
}

const ListItem:React.FC<ListItemProps> = ({ icon, style, primary, secondary }) => {
    return (
        <li className="dry-design-list-item" style={{...style}}>
            <div className="dry-design-list-item-wrapper">
                {icon && <div className="dry-design-li-icon">{icon}</div>}
                <div className="dry-design-li-text">
                    <div className="primary">{primary}</div>
                    <div className="secondary">{secondary}</div>
                </div>
            </div>
        </li>
    )
}

export default ListItem;